module.exports = __webpack_public_path__ + "static/media/legend.47377913.png";